import { render } from "./LoginView.vue?vue&type=template&id=804454ee&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=804454ee&lang=scss&scoped=true"

import exportComponent from "/root/workspace/tang-h5_cUXP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804454ee"]])

export default __exports__